import { ScheduleDay } from './types';
import { DEFAULT_SCHEDULE, DAY_API_MAP } from './constants';
import {
  WeeklyScheduleDao,
  TimeRange,
} from '../../../../models/Settings/WeeklySchedule';
import { expandSpecialDateRanges, normalizeSpecialDate } from './specialDates';

const timeToShort = (t: string): string => t.slice(0, 5);

const timeToLong = (t: string): string => (t.length === 5 ? `${t}:00` : t);

export const weeklyScheduleToLocal = (
  dao: WeeklyScheduleDao,
): { schedule: ScheduleDay[]; holidays: string[] } => {
  const schedule = DEFAULT_SCHEDULE.map((d) => {
    const apiKey = DAY_API_MAP[d.day];
    const range = dao[apiKey] as TimeRange | null;
    if (!range) return { ...d, start: null, end: null };
    return { ...d, start: timeToShort(range.from), end: timeToShort(range.to) };
  });

  const holidays = expandSpecialDateRanges(dao.holidays, 'local');

  return { schedule, holidays };
};

export const localToWeeklySchedule = (
  schedule: ScheduleDay[],
  holidays: string[],
): WeeklyScheduleDao => {
  const dao: Record<string, TimeRange | null> = {};

  for (const d of schedule) {
    const apiKey = DAY_API_MAP[d.day];
    dao[apiKey] =
      d.start !== null && d.end !== null
        ? { from: timeToLong(d.start), to: timeToLong(d.end) }
        : null;
  }

  const apiHolidays = expandSpecialDateRanges(holidays).map((holiday) =>
    normalizeSpecialDate(holiday),
  );

  return {
    ...(dao as Omit<WeeklyScheduleDao, 'holidays'>),
    holidays: apiHolidays,
  } as WeeklyScheduleDao;
};
